import * as tslib_1 from "tslib";
import { CanActivate } from '@angular/router';
import { ConfigService } from '../services/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/config.service";
export class WalletGuard {
    constructor(configService) {
        this.configService = configService;
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.configService.getInitialInfo().then((response) => {
                return response;
            });
            return yield this.configService.company_info.wallet_active;
        });
    }
}
WalletGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WalletGuard_Factory() { return new WalletGuard(i0.ɵɵinject(i1.ConfigService)); }, token: WalletGuard, providedIn: "root" });
